/** @format */

import { useQuery } from "@tanstack/react-query";
import service from "../utils/service";

const useGetAllSurvey = () => {
  const allSurvey = useQuery({
    queryKey: ["getAllSurvey"],
    queryFn: () => service.getAll(),
    select: (data) => data.data,
  });
  return allSurvey;
};

export default useGetAllSurvey;
